import React from 'react';
import { ReactComponent as LogoSvg } from '../../../assets/marimosca-main-logo.svg';
import styles from './Logo.module.css';

interface LogoProps {
  height?: number;
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ height = 36, className = '' }) => {
  return (
    <div className={`${styles['logo-wrapper']} ${className}`}>
      <LogoSvg className={styles.logo} style={{ height }} />
    </div>
  );
};

export default Logo;
